// extracted by mini-css-extract-plugin
module.exports = {"Card":"FileCard_Card__66MZM","FileIcon":"FileCard_FileIcon__1siIT","FileName":"FileCard_FileName__oR__z","FileRemoveButtonDummy":"FileCard_FileRemoveButtonDummy__1vYcs"};